import React from 'react';
import {Grid, Container, Segment, Menu, Message} from 'semantic-ui-react';

// import Items from "./Items.js"

class CameraCollection extends React.Component{

    props = {
        Datapath: "./data/SensorDump.json"
    }

    state = {
        activeItem: "Overview",
        CardData: { F0: { P0: {Value: 0},  P1: {Value: 0}, P2: {Value: 0}, P3: {Value: 0} },
                    F1: { P0: {Value: 0},  P1: {Value: 0}, P2: {Value: 0}, P3: {Value: 0} },
        },
        Images: {
            NW: "./anim/cw66.gif",
            SW: "./anim/cw70.gif",
            SE: "./anim/cw68.gif",
            NE: "./anim/cw72.gif"
        },
        Thumbs:{
            NW: "./images/thumbs/cw66.gif",
            SW: "./images/thumbs/cw70.gif",
            SE: "./images/thumbs/cw68.gif",
            NE: "./images/thumbs/cw72.gif"
        }
    }

   constructor(props){
        super(props);
        
        fetch(this.props.Datapath)
        .then(response => response.json())
        .then(json => {
            this.setState({
                CardData: json
                })
        });
    }



    FormattedData(){

        function UniqueRequests(data){
            var UniqueSet = []
            var TrackerSet = []
            data.forEach( (y) => {
                if(TrackerSet.includes(y.Label)){
                }
                else{
                    UniqueSet.push(y);
                    TrackerSet.push(y.Label);
                }
            })
            return UniqueSet;
        };

        const d = Object.values(this.state.CardData);
        const p = Object.values(d);
        const f = d.filter(x => x.RequestString === undefined );
        const c = f.map(x => Object.values(x));
        const v = c.reduce((a,e) => a.concat(e),[]);
        const final = UniqueRequests(v);

        console.log(final);
        
        return final;
    }

    ConstructPil(fullhref, smallhref){
        const Container = {
            overflow: "hidden"
            };
        const Image = {
            width: "100%"
            };
        return(
            <div style={Container}>
                <img src={fullhref} style={Image} />
                {/* <ProgressiveImage
                    preview={smallhref}
                    src={fullhref}
                    transitionTime={1000}
                    transitionFunction="ease-in"
                    render={(src, style) => <img src={src} style={{...style, ...Image}} />}
                /> */}
            </div>
        )
    }

    HumidityTooltip(DirStr, Value){
        if(Value == null){
            return(
                <div style={{backgroundColor:"#FFF"}}>
                    {DirStr}: Data Unavailable
                </div>
            )
        }
        else if(Value < 70){
            return(
                <div style={{backgroundColor:"#FFF"}}>
                    {DirStr}: {Value} %
                </div>
            )
        }
        else if(Value < 80){
            return(
                <div style={{backgroundColor:"#F3F039"}}>
                    {DirStr}: {Value} %
                </div>
            )
        }
        else{
            return(
                <div style={{backgroundColor:"#F33"}}>
                    {DirStr}: {Value} %
                </div>
            )
        }
    }

    TemperatureTooltip(DirStr, Value){
        if(Value == null){
            return(
                <div style={{backgroundColor:"#FFF"}}>
                    {DirStr}: Data Unavailable
                </div>
            )
        }
        else if(0 <= Value <= 100){
            return(
                <div style={{backgroundColor:"#FFF"}}>
                    {DirStr}: {Value} C
                </div>
            )
        }
        else{
            return(
                <div style={{backgroundColor:"#F33"}}>
                    {DirStr}: {Value} ?
                </div>
            )
        }
    }





    QuadLayout(Data){ 
        // const {a,b,...c} = Data;//Data.find((o) => o.Label === "Inside Humidity");
        // const NW = Data.find((o) => o.Label === "Inside Humidity");
        // const SE = Data.find((o) => o.Label === "Inside Humidity");
        // const SW = Data.find((o) => o.Label === "Inside Humidity");

        // console.log(Data[1]["Value"]);
        // console.log(b);
        // console.log(c);
        //console.log(this.state.CardData);

        return (
            <Segment.Group vertical>
                <Segment.Group horizontal>
                    <Segment textAlign={"center"}>
                        {this.ConstructPil(this.state.Images.NW, this.state.Thumbs.NW)}
                         Northwest<br/>
                        {this.HumidityTooltip("Humidity NW", this.state.CardData.F0.P1.Value)}
                        {this.TemperatureTooltip("Temperature NW", this.state.CardData.F1.P1.Value)}
                    </Segment>
                    <Segment textAlign={"center"}>
                        {this.ConstructPil(this.state.Images.SE, this.state.Thumbs.SE)}
                        Southeast<br/>
                        {this.HumidityTooltip("Humidity SE", this.state.CardData.F0.P2.Value)}
                        {this.TemperatureTooltip("Temperature SE", this.state.CardData.F1.P2.Value)}
                    </Segment>
                </Segment.Group>
                <Segment.Group horizontal>
                    <Segment textAlign={"center"}>
                        {this.ConstructPil(this.state.Images.SW, this.state.Thumbs.SW)}
                        Southwest<br/>
                        {this.HumidityTooltip("Humidity SW", this.state.CardData.F0.P3.Value)}
                        {this.TemperatureTooltip("Temperature SW", this.state.CardData.F1.P3.Value)}
                    </Segment>
                    <Segment textAlign={"center"}>
                        {this.ConstructPil(this.state.Images.NE, this.state.Thumbs.NE)}
                        Northeast<br/>
                        {this.HumidityTooltip("Humidity NE", this.state.CardData.F0.P0.Value)}
                        {this.TemperatureTooltip("Temperature NE", this.state.CardData.F1.P0.Value)}
                    </Segment>
                </Segment.Group>
            </Segment.Group>
            // <Grid columns={2} compact>
            //     <Grid.Row>
            //         <Grid.Column>
            //             {this.ConstructPil(this.state.Images.N, this.state.Thumbs.N)}
            //         </Grid.Column>
            //         <Grid.Column>
            //             {this.ConstructPil(this.state.Images.W, this.state.Thumbs.W)}
            //         </Grid.Column>
            //     </Grid.Row>
            //     <Grid.Row>
            //         <Grid.Column>
            //             {this.ConstructPil(this.state.Images.E, this.state.Thumbs.E)}
            //         </Grid.Column>
            //         <Grid.Column>
            //             {this.ConstructPil(this.state.Images.S, this.state.Thumbs.S)}
            //         </Grid.Column>
            //     </Grid.Row>
            // </Grid>
        );
    }

    VerticalLayout = (
        <Grid columns={1} celled={"internally"}>
            <Grid.Row>
                {this.ConstructPil(this.state.Images.NW, this.state.Thumbs.NW)}
            </Grid.Row>
            <Grid.Row>
                {this.ConstructPil(this.state.Images.SW, this.state.Thumbs.SW)}
            </Grid.Row>
            <Grid.Row>
                {this.ConstructPil(this.state.Images.SE, this.state.Thumbs.SE)}
            </Grid.Row>
            <Grid.Row>
                {this.ConstructPil(this.state.Images.NE, this.state.Thumbs.NE)}
            </Grid.Row>
        </Grid>
    );
    
    HandleItemClick = (e, { name }) => this.setState({ activeItem: name })

    render(){

        const { activeItem } = this.state
        const menu = {
            width: "100%"
        }

        var values = [];

        return(
            <Container fluid stretched >

                <Menu fluid pointing style={menu} attached={"bottom"}>
                    <Menu.Item 
                        as={"a"}
                        name={"Overview"}
                        active={activeItem === "Overview"} 
                        onClick={this.HandleItemClick} 
                    />
                    <Menu.Item
                        as={"a"}
                        name={"NW"}
                        active={activeItem === "NW"}
                        onClick={this.HandleItemClick}
                    />
                    <Menu.Item
                        as={"a"}
                        name={"SW"}
                        active={activeItem === "SW"}
                        onClick={this.HandleItemClick}
                    />
                    <Menu.Item
                        as={"a"}
                        name={"SE"}
                        active={activeItem === "SE"}
                        onClick={this.HandleItemClick}
                    />
                    <Menu.Item
                        as={"a"}
                        name={"NE"}
                        active={activeItem === "NE"}
                        onClick={this.HandleItemClick}
                    />
                </Menu>

                {/* <Segment.Group> */}

                    
                    {activeItem==="Overview" && this.QuadLayout(this.FormattedData())}
                    {activeItem==="NW" && <Segment> {this.ConstructPil(this.state.Images.NW, this.state.Thumbs.NW)} </Segment>}
                    {activeItem==="SW" && <Segment> {this.ConstructPil(this.state.Images.SW, this.state.Thumbs.SW)} </Segment>}
                    {activeItem==="SE" && <Segment> {this.ConstructPil(this.state.Images.SE, this.state.Thumbs.SE)} </Segment>}
                    {activeItem==="NE" && <Segment> {this.ConstructPil(this.state.Images.NE, this.state.Thumbs.NE)} </Segment>}
                    

                    {/* <Segment.Group horizontal>
                        <Segment textAlign={"center"} color={"grey"}>
                            North<br/>Humidity: - - -
                        </Segment>
                        <Segment textAlign={"center"} color={"grey"}>
                            West<br/>Humidity: - - -
                        </Segment>
                        <Segment textAlign={"center"} color={"grey"}>
                            East<br/>Humidity: - - -
                        </Segment>
                        <Segment textAlign={"center"} color={"grey"}>
                            South<br/>Humidity: - - -
                        </Segment>
                    </Segment.Group> */}
                    
                {/* </Segment.Group> */}
                
            </Container>
        )
    };

}

export default CameraCollection;
